export enum ServiceType {
  Compute = 'compute',
  Image = 'image',
  Storage = 'storage',
  Network = 'network',
}

export enum ServiceState {
  Up = 'up',
  Down = 'down',
  NetworkError = 'network_error',
  CertificateError = 'certificate_error',
}

export enum ServiceStatus {
  Healthy = 'Healthy',
  Unhealthy = 'Unhealthy',
  Maintenance = 'Maintenance',
  NetworkError = 'Network Error',
  CertificateError = 'Trust Image Library Certificate',
  Loading = 'Loading',
  Unknown = 'Unknown',
  SchedulingDisabled = 'Scheduling Disabled',
}
